/**
 * @description: 右侧嵌套列表组件
 * @author:
 */
<template>
  <div class="detail-min-table" :style="{width, height}">
    <div class="row head">
      <div v-for="item in option.head" :key="item.prop" class="item" :style="{width: '100px', ...item.style||{}}">
        {{item.label}}
      </div>
    </div>
    <div class="center" v-if="value.length">
      <div v-for="(center, index) in value" :key="index">
        <div class="row">
          <div v-for="item in option.head" :key="item.prop" class="item" :style="{width: '100px', ...item.style||{}}">
            <template v-if="item.prop === 'index'">
              {{index + 1}}
            </template>
            <slot :name="`${item.prop}Slot`" v-if="item.slot" :item="center" />
            <!-- 收寄件人手机显示 -->
            <EyesPhone
              v-else-if="item.decode"
              :paramsData="{
                phone:center[item.prop],
                waybillNo: center.waybillNo,
                queryType: item.type,// 1:寄件 2：收件
              }"
            />
            <template v-else-if="item.formatter && typeof item.formatter === 'function'">{{item.formatter(center)}}</template>
            <template v-else-if="item.type && item.type === 'enclosure' && center[item.prop]" style="">
              <div class="enclosure_text">
              <span v-if="center[item.prop][0].length" @click="showAndDown(center[item.prop][0])">查看</span><span style="margin-left: 10px;" v-if="center[item.prop][1].length"  @click="fileList(center[item.prop][1])">下载</span>
              </div>
            </template>
            <template v-else>{{center[item.prop]}}</template>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="none-date">{{$lang('暂无数据')}}</div>
  <List-of-attachments :isShowModdia="showFileDialog" @close="closeDialog" :fileDataUrl="fileData"> </List-of-attachments>

  </div>
</template>

<script>
import ListOfAttachments from '../ListOfAttachments'
export default {
  components: {
    ListOfAttachments
  },
  data() {
    return {
      showFileDialog: false,
      fileData: []
    }
  },
  props: {
    option: Object,
    value: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: 'auto'
    }
  },
  watch: {
    'value': {
      handler(o) {
        console.log(o)
      }
    }
  },
  methods: {
    // 查看图片
    showAndDown (e) {
      console.log(e, '哈哈哈')
      // if (e.lengh) {
      this.$openImagePreview(e, 0, null, true)
      // }
    },
    closeDialog(e) {
      this.showFileDialog = e
      console.log(e)
    },
    fileList(file = []) {
      if (file.length === 1) {
        window.location.href = file
      }
      if (file.length > 1) {
        this.fileData = file
        this.showFileDialog = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-min-table {
  border: 1px solid #ddd;
  overflow-x: hidden;
  overflow-y: auto;
  .head.row {
    border: 0;
    font-weight: bold;
    @include bg-color('pop-active');
  }
}
.row {
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: stretch;

  .item {
    float: left;
    word-break: break-all;
    white-space: normal;
    padding: 10px;
    font-size: 12px;
    line-height: 16px;
    &:not(:first-child) {
      border-left: 1px solid #ddd;
    }
    .enclosure_text{
      cursor:pointer;
      @include base-color('clr');
    }
    .iconxianshi {
      font-size: 12px;
    }
  }
}
.none-date {
  text-align: center;
  font-size: 12px;
  line-height: 60px;
  color: #909399;
  max-width: calc(100vw - 420px);
}
.head {
  line-height: 40px;
  height: 40px;
}
.center {
  overflow: hidden;
  .row {
    border-top: 1px solid #ddd;
  }
}
.detial-view {
  border-top: 1px solid #ddd;
}
</style>

